import { Box, Divider, Stack, IconButton } from "@mui/material";
import theme from "Theme/AppTheme";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import AcxSelectMulti from "components/UI/Select/BaseSelectComponents/AcxSelectMulti";
import { observer } from "mobx-react";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { customFilterSelectStyles } from "../../shared";
import OutlineFilterStore, {
    IOutlineFilter,
    OutlineSegmentOption,
} from "./OutlineFilterStore";

interface Props {
    item: IOutlineFilter;
    index: number;
    store: OutlineFilterStore;
}

const OutlineFilterItem: React.FunctionComponent<Props> = observer(
    ({ item, index, store }) => {
        const selectedItems = store.outlineSegmentOptions.filter((option) =>
            item.segments.includes(option.id),
        );

        const nextItem =
            index !== store.outlineFilterItems.length - 1
                ? store.outlineFilterItems[index + 1]
                : undefined;

        const showAndOrChip =
            store.outlineFilterItems.length !== 1 &&
            index !== store.outlineFilterItems.length - 1;

        const isAnd = item.filterGroupId === nextItem?.filterGroupId;

        const selectOptions = [
            { label: "Contains", value: true },
            {
                label: "Does not contain",
                value: false,
            },
        ];

        const handleSegmentsChange = (arg?: OutlineSegmentOption[]) => {
            item = {
                ...item,
                segments: arg?.map((option) => option.id) ?? [],
            };
            store.setOutlineFilterItem(index, item);
        };

        const renderAndOr = (
            <Stack
                direction="row"
                sx={{
                    marginTop: "12px",
                    marginBottom: "12px",
                    height: "28px",
                    position: "relative",
                }}
                justifyContent={isAnd ? "flex-start" : "center"}
                alignItems="center"
            >
                {!isAnd && (
                    <Divider
                        sx={{
                            width: "100%",
                            backgroundColor: theme.palette.lightBlue.background,
                            height: "2px",
                        }}
                    />
                )}
                <Stack
                    direction="row"
                    sx={{
                        color: "#1E40AF",
                        backgroundColor: theme.palette.lightBlue.background,
                        borderRadius: "4px",
                        padding: "5px 10px 5px 10px",
                        position: "absolute",
                        cursor: "pointer",
                    }}
                    alignItems={"center"}
                    onClick={() => {
                        store.changeOutlineCombinator(index, !isAnd ? 0 : 1);
                    }}
                >
                    <Box fontWeight={"bold"}>{isAnd ? "AND" : "OR"}</Box>
                </Stack>
            </Stack>
        );

        return (
            <>
                <Stack
                    sx={{
                        padding: "8px",
                        backgroundColor: theme.palette.lightgray.main,
                        borderRadius: "4px",
                        width: "100%",
                    }}
                >
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{
                            "&:hover .closeButton": {
                                visibility: "visible",
                            },
                        }}
                    >
                        <AcxSelect
                            id={"outline-filter-item-select-" + index}
                            options={selectOptions}
                            defaultValue={{
                                label: item.value
                                    ? "Contains"
                                    : "Does not contain",
                                value: item.value,
                            }}
                            customStyle={customFilterSelectStyles}
                            onChange={(item) => {
                                store.updateOutlineItemContains(
                                    index,
                                    item.value,
                                );
                            }}
                        />
                        {index !== 0 && (
                            <IconButton
                                onClick={() =>
                                    store.removeOutlineFilterItem(index)
                                }
                                size="small"
                                className="closeButton"
                                sx={{ visibility: "hidden" }}
                            >
                                <CloseIcon />
                            </IconButton>
                        )}
                    </Stack>
                    <AcxSelectMulti
                        id="application-filters-outline"
                        options={store.outlineSegmentOptions}
                        onChange={handleSegmentsChange}
                        valueField="id"
                        labelField="name"
                        defaultValue={selectedItems}
                        containerHeight="auto"
                        maxContainerHeight="96px"
                        alignControls="flex-start"
                        isClearable={true}
                    />
                </Stack>
                {showAndOrChip && renderAndOr}
            </>
        );
    },
);

export default OutlineFilterItem;
